import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../../../services/types/filter.types';
import { databoxDmsMessageAttachmentGridItemFrag } from './types/databox-dms-message-attachment.gql-types';
import {
    DataboxDmsMessageAttachmentGridObject,
} from '@libs/types/src/inbox/object-type/databox-dms-message-attachment.object';

@Injectable({ providedIn: 'root' })
export class DataboxDmsMessageAttachmentGqlService extends GqlServiceV2 {

    getDataboxDmsMessageAttachments(input: GridInput, frag: string = databoxDmsMessageAttachmentGridItemFrag) {
        return this.query<DataboxDmsMessageAttachmentGridObject>(
            `
                query($input: GridInput!) {
                    databoxDmsMessageAttachment {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }
}
